import React, { useEffect } from "react";
import { Form, Input, Modal } from "antd";

/**
 * Установка пароля сотрудника (как Delphi TFrmEnterPass).
 */
const SprSotrPasswordModal = ({ open, onCancel, onOk, loading = false }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);

  const submit = async () => {
    const values = await form.validateFields();
    await onOk?.(values.password);
  };

  return (
    <Modal
      title="Пароль"
      open={open}
      onCancel={onCancel}
      onOk={submit}
      okText="OK"
      cancelText="Отмена"
      confirmLoading={loading}
      destroyOnClose
    >
      <Form form={form} layout="vertical" colon={false}>
        <Form.Item
          label="Пароль"
          name="password"
          rules={[{ required: true, message: "Введите пароль" }]}
        >
          <Input.Password autoFocus />
        </Form.Item>
        <Form.Item
          label="Подтверждение"
          name="password2"
          dependencies={["password"]}
          rules={[
            { required: true, message: "Повторите пароль" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Пароли не совпадают"));
              }
            })
          ]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SprSotrPasswordModal;
